<template lang="pug" src="./custom-treatment-sections.pug"></template>

<script>

export default {
  // data () {
  //   return {
  //     sliding: false
  //   }
  // },
  props: ['props'],
  methods: {
    fadeUp (i) {
      if (i === 1 || i === 2) {
        this.$refs.img[i].classList.add('slide-in')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-treatment-sections.vue?ffd244aa